import config from "appConfig";
import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "701dc53f-ea04-4157-be72-9ed3c50f4e0e",
    content: `A circular room<br/> (in plan)`,
    options: {
      image: `${config.ASSETS_URL}/05/30/task/task-1-item-1.svg`,
    },
  },
  {
    id: "7c790275-69ad-4525-97f5-36a182dfdb53",
    content: `An unparallel shape in<br /> a rectangular room (in plan)`,
    options: {
      image: `${config.ASSETS_URL}/05/30/task/task-1-item-3.svg`,
    },
  },
  {
    id: "38f74c33-d33d-4235-ab68-b01561ed5259",
    content: `A heptagonal shape in<br /> a circular room (in plan)`,
    options: {
      image: `${config.ASSETS_URL}/05/30/task/task-1-item-2.svg`,
    },
  },
  {
    id: "b1796d4e-007c-43c4-8b45-eb68cb7c99e2",
    content: `An unparallel shape in<br /> a rectangular room (in section)`,
    options: {
      image: `${config.ASSETS_URL}/05/30/task/task-1-item-4.svg`,
    },
  },
];

export const task: Task = {
  id: "976c6602-bba0-45c1-a465-73530e43d9e8",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: false,
    columns: 2,
    imageViewType: "fill",
    imageHeight: 172,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7c790275-69ad-4525-97f5-36a182dfdb53", "b1796d4e-007c-43c4-8b45-eb68cb7c99e2"],
};
